import type { ApiStrapiProduct } from './types';

export class ProductService {
  private client = useStrapiClient();
  private populate = {
    image: { populate: ['file'] },
    category: { populate: '*' },
    seo: { populate: '*' },
  };
  private async find(params: Record<string, unknown>): Promise<ApiStrapiProduct[]> {
    try {
      const response = await this.client<{ data: ApiStrapiProduct[] }>('/products', {
        params: { status: 'published', ...params },
        timeout: 10000,
      });
      return response?.data ?? [];
    } catch {
      throw new Error('Не удалось загрузить каталог. Попробуйте ещё раз.');
    }
  }
  getAllProducts() {
    return this.find({ populate: this.populate, pagination: { pageSize: 100 } });
  }
  getProductByCategory(route: string) {
    return this.find({
      filters: {
        category: {
          $or: [
            { route: { $eq: route } },
            { slug: { $eq: route } },
            { documentId: { $eq: route } },
          ],
        },
      },
      populate: this.populate,
      pagination: { pageSize: 100 },
    });
  }
  async getProductBySlug(slug: string) {
    const products = await this.find({
      filters: {
        $or: [
          { slug: { $eq: slug } },
          { documentId: { $eq: slug } },
          ...(/^\d+$/.test(slug) ? [{ id: { $eq: Number(slug) } }] : []),
        ],
      },
      populate: { ...this.populate, specs: { populate: '*' } },
    });
    return products[0] ?? null;
  }
  getBySlugs(slugs: string[]) {
    return this.find({
      filters: { $or: [{ slug: { $in: slugs } }, { documentId: { $in: slugs } }] },
      populate: this.populate,
    });
  }
}
